const getters = {
  CONTENT_TYPE: state => state.app.CONTENT_TYPE,
  PAGE: state => state.app.PAGE,
  nodeCode: state => state.app.nodeCode,
  shareRootUrl: state => state.app.shareRootUrl,
  token: state => state.app.token,
  userInfo: state => state.app.userInfo,
  statusBarHeight: state => state.app.statusBarHeight,
}
export default getters
